module.exports = __webpack_public_path__ + "static/media/Lost Travel Document _ Credit Card  Assistance.699ff313.png";